import React from 'react';
import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import strings from 'strings';
import { FPActionButton } from 'UI/components/atoms';
import SaveButton from 'UI/components/atoms/SaveButton';

import { FiltersList } from '../FiltersList';

import { useFiltersStyles } from './Filters.styled';

export const Filters = React.memo(({ useFiltersFormInstance }) => {
  const classes = useFiltersStyles();
  const {
    uiState,
    formValues,
    hasActiveFilters,
    handleFilterChange,
    handleAdvancedSearch,
    handleClearSearch
  } = useFiltersFormInstance;

  return (
    <Box className={classes.filtersContainer}>
      <Box className={classes.filtersWrapper}>
        <Typography variant="h6">{strings.shared.ui.filters}</Typography>
        <Divider />
        <FiltersList formValues={formValues} onFilterChange={handleFilterChange} />
      </Box>
      <Box className={classes.footerButtonsContainer}>
        <SaveButton
          disabled={!hasActiveFilters}
          isSaving={uiState.submitting}
          initialText={strings.resumeSearch.filters.footer.advancedSearch}
          onProgressText={strings.shared.ui.working}
          onClick={handleAdvancedSearch}
          fullWidth
        />
        <FPActionButton
          text={strings.resumeSearch.filters.footer.clearSearch}
          onClick={handleClearSearch}
          variant="outlined"
          fullWidth
        />
      </Box>
    </Box>
  );
});
